<template>
  <span class="c-button-loading">
    <span class="c-button-loading__icon" />
    <span class="c-button-loading__icon" />
    <span class="c-button-loading__icon" />
  </span>
</template>

<script>
export default {
  name: 'ButtonLoading',
}
</script>

<style lang="stylus" scoped>
.c-button-loading
  position absolute
  width 100%
  display flex
  justify-content center
  align-items center
  top 50%
  left 0
  transform translateY(-50%)

  &__icon
    animation loadingPulse 1s infinite
    background rgba(72, 72, 72, 0.4)
    height calc(0.5em + 2px)
    width calc(0.5em + 2px)
    float left
    margin-left 5px
    border-radius 50%
    &:nth-of-type(2)
      animation-delay 0.15s
    &:nth-of-type(3)
      animation-delay 0.3s
    &:first-child
      margin-left 0

@keyframes loadingPulse
  0%, 100%, 10%, 90%
    transform: scale(0.75)
  50%
    transform: scale(1)
</style>
